<template>
    <div v-if="$parent.mediaProperty.configuration" class="configuration">
        <div class="formRow">
            <h4>Location URL*:</h4>
            <input type="text" v-model="$parent.mediaProperty.configuration.location" @change="saveAudio" :disabled="!$parent.mediaProperty.isActive"/>
        </div>
        <div class="formRow">
            <h4>Captions Location URL:</h4>
            <input type="text" v-model="$parent.mediaProperty.configuration.closedCaptionsLocation" @change="saveAudio" :disabled="!$parent.mediaProperty.isActive"/>
        </div>
        <div class="formRow">
            <h4>File Type</h4>
            <select v-model="$parent.mediaProperty.configuration.fileType" @change="saveAudio" :disabled="!$parent.mediaProperty.isActive">
                <option value=""></option>
                <option v-for="record in fileTypes" :key="record.value" :value="record.displayName">{{record.internalName}}</option>
            </select>
        </div>
        <div class="formRow">
            <h4>Is this a local path?</h4>
            <input type="checkbox" v-model="$parent.mediaProperty.configuration.isLocalPath" @change="saveAudio" :disabled="!$parent.mediaProperty.isActive"/>
        </div>
        <div class="formRow">
            <h4>Show Controls?</h4>
            <input type="checkbox" v-model="$parent.mediaProperty.configuration.showControls" @change="saveAudio" :disabled="!$parent.mediaProperty.isActive"/>
        </div>
        <div class="formRow">
            <h4>Milliseconds To Wait Before Next Audio Plays</h4>
            <input type="number" min="0" step="1" style="width:80px;" v-model="$parent.mediaProperty.configuration.millisecondsBeforeNextAudio" @change="saveAudio" :disabled="!$parent.mediaProperty.isActive"/>
        </div>
        <div class="formRow" v-if="!$parent.mediaProperty.configuration.isLocalPath && publicPermission">
            <h4>Access:</h4>
            <select v-model="publicPermission" @change="updatePermissions">
                <option value="public-read">Public</option>
                <option value="private">Private</option>
            </select>
        </div>
        <div class="formRow" v-if="!$parent.mediaProperty.configuration.isLocalPath">
            <h4></h4>
            <UploadMediaPropertyModal openButtonText="Upload Audio"
                                        modalTitle="Upload Audio"
                                        :fileKey="$parent.mediaProperty.configuration.location"
                                        acceptFileTypes="audio/*"
                                        :onFileUpload="onAudioUpload"
                                        srcAddress="Location URL"></UploadMediaPropertyModal>
        </div>
        <div class="formRow" v-if="audioLink">
            <h4>Audio preview</h4>
            <div>
                <audio controls>
                    <source :src="audioLink" :type="$parent.mediaProperty.configuration.fileType" :key="audioKey">
                </audio>
            </div>
        </div>
        <div class="formRow" style="margin-top:20px;align-items: start;">
            <h4>Captions</h4>
            <div>
                <div class="new-captions">
                    <h4>Add Captions</h4>
                    <div class="button">
                        <button class="primaryButton" @click="generateVTT">Generate VTT from Sonix</button>
                    </div>
                    <div class="upload">
                        <UploadMediaPropertyModal openButtonText="Upload From Computer"
                                                modalTitle="Upload Captions"
                                                :fileKey="$parent.mediaProperty.configuration.closedCaptionsLocation"
                                                acceptFileTypes=".vtt, .srt"
                                                :onFileUpload="getCCLink"
                                                srcAddress="Captions Location URL"></UploadMediaPropertyModal>
                    </div>
                </div>
            </div>
        </div>
        <div class="formRow" v-if="ccLink">
            <h4></h4>
            <div style="display: flex;flex-direction: column;">
                <div v-if="$parent.mediaProperty.configuration.ccFileIsAutoGenerated" style="display:flex;flex-direction:column;">
                    <p>**This file has been automatically generated by a transcription service**</p>
                    <div v-if="newestTranscriptionIsUnvalidated">
                        <p>This audio's transcription is not yet validated</p>
                        <button @click="goToTranscription" class="primaryButton">View Transcription</button>
                    </div>
                </div>
                <p><a class="primaryButton" :href="ccLink" target="_blank" style="padding: 5px 10px;text-decoration: none;">Download Caption File</a></p>
            </div>
        </div>
    </div>
</template>

<script>
import {data} from '../../shared/data';
import {storage} from '../../shared/storage';
import UploadMediaPropertyModal from './UploadMediaPropertyModal.vue';

export default {
    name: 'AudioEdit',
    components: { UploadMediaPropertyModal },
    data: function() {
        return {
            fileTypes: [],
            audioKey: 0,
            publicPermission: null,
            audioLink: null,
            ccLink: null
        }
    },
    computed: {
        validated() {
            let configuration = this.$parent.mediaProperty.configuration;
            return (
                configuration.location &&
                configuration.location.length > 0
            )
        },
        newestTranscriptionIsUnvalidated() {
            return this.$parent.mediaProperty.aiTranscriptions.length && this.newestTranscription.statusCode !== 'Validated';
        },
        newestTranscription() {
            const array = this.$parent.mediaProperty.aiTranscriptions;
            return array.sort((a,b) => a.lastModifiedDateTime - b.lastModifiedDateTime)[0];
        }
    },
    async mounted() {
        if(!this.$parent.mediaProperty.configuration) {
            this.$parent.mediaProperty.configuration = {
                location: '',
                closedCaptionsLocation: '',
                showControls: false,
                isLocalPath: false,
                millisecondsBeforeNextAudio: 0,
                fileType: 'audio/mpeg'
            }
        }
        if(this.$parent.mediaProperty.configuration.location) {
            this.publicPermission = await storage.checkPermission(this.$parent.mediaProperty.configuration.location);
            await this.getAudioLink();
        }
        if(this.$parent.mediaProperty.configuration.closedCaptionsLocation)
            await this.getCCLink();

        this.fileTypes = await data.getEnumList("AudioFileTypes");
        this.fileTypes = this.fileTypes.filter(search => search.internalName != "NotSet");
    },
    methods: {
        saveAudio: async function() {
            if(this.validated) {
                const resp = this.processSaveResult(await data.saveMediaProperty(this.$parent.mediaProperty))
                if(!this.$parent.mediaProperty.id && resp.id) {
                    this.$parent.mediaProperty.id = resp.id;
                    this.$router.replace({path: this.$route.path, query: { ID: this.$parent.mediaProperty.id}});
                }
            }
            else
                this.$toast.error('Location is required');
        },
        onAudioUpload: async function() {
            this.publicPermission = await storage.checkPermission(this.$parent.mediaProperty.configuration.location);
            await this.getAudioLink();
        },
        getAudioLink: async function() {
            this.audioLink = await storage.getWasabiLink(this.$parent.mediaProperty.configuration.location, this.publicPermission === 'public-read');
            this.audioKey++;
        },
        getCCLink: async function() {
            this.ccLink = await storage.getWasabiLink(this.$parent.mediaProperty.configuration.closedCaptionsLocation, this.publicPermission === 'public-read');
        },
        updatePermissions: async function() {
            if(this.$parent.mediaProperty.configuration.location) {
                await storage.updateStoragePermissions(this.$parent.mediaProperty.configuration.location, this.publicPermission, null, this.getAudioLink);
            }
            if(this.$parent.mediaProperty.configuration.closedCaptionsLocation) {
                await storage.updateStoragePermissions(this.$parent.mediaProperty.configuration.closedCaptionsLocation, this.publicPermission, null, this.getCCLink);
            }
        },
        generateVTT: async function() {
            if(this.$parent.mediaProperty.aiTranscriptions.length)
                if(!confirm('This will submit the audio for auto-transcribing even though this audio already has a VTT file. Proceed?'))
                    return;
            else
                if(!confirm('This will submit the audio for auto-transcribing. Proceed?'))
                    return;
            const response = await data.submitMediaForTranscription(this.$parent.mediaProperty.id, this.audioLink, this.$parent.mediaProperty.defaultLanguage);
            if(response.success) {
                this.$toast.success('Audio submitted for transcription');
                this.$parent.mediaProperty.configuration.ccFileIsAutoGenerated = true;
                this.saveAudio();
                this.$parent.mediaProperty.aiTranscriptions = await data.browseAITranscriptionsByMediaPropertyId(this.$parent.mediaProperty.id);
            }
            else if(response.errors)
                this.$toast.error(response.errors.join('<br/>'));
        },
        goToTranscription: function() {
            window.location.href = '/AITranscriptionEdit?ID=' + this.newestTranscription.id;
        }
    }
}
</script>

<style scoped>
    .primaryButton {
        height: 40px;
        width: 180px;
        border-radius: 5px;
        border-color: #036991;
        background-color: #036991;
        color: white;
        cursor: pointer;
        font-size: 16px;
    }
    .new-captions {
        display: flex;
        flex-direction: column;
        background: rgb(241,243,244);
        border-radius: 10px;
        padding: 10px;
        max-width: 250px;
    }
    .new-captions .upload {
        flex: 1 1 50px;
        padding-top: 10px;
    }
    .new-captions .button {
        flex: 1 1 50px;
        border-bottom: solid 1px lightgray;
    }
</style>